import { useQuery } from '@tanstack/react-query';
import { getUserById } from '../api/USERS/users';

export const useGetUserById = (userId) => {
    return useQuery({
        queryKey: ['user', userId],
        queryFn: () => getUserById(userId),
        enabled: !!userId,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};
